module.exports = __webpack_public_path__ + "img/flame_animation.a5424580.gif";